globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.ModalInteractionsFormSubmissionsExcelExport = (function(superClass)
{
    utils.extend(ModalInteractionsFormSubmissionsExcelExport, superClass);

    function ModalInteractionsFormSubmissionsExcelExport($html) {
        this.$html = $html;
        return ModalInteractionsFormSubmissionsExcelExport.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalInteractionsFormSubmissionsExcelExport.prototype, {
        init: function() {
            var modal = this;

            appCustomerSpace.LimitlessPlugins.Selects.Single.init(modal.$html);
            exportExcelActionCable(modal.$html);
            ModalInteractionsFormSubmissionsExcelExport.__super__.init.apply(this, arguments);

            this.$html.find("button[type='close']").on('click', function(e) {
                e.preventDefault();
                modal.close();
                $('body').removeClass('modal-open');
            });
        }

    });

    return ModalInteractionsFormSubmissionsExcelExport;
})(appCustomerSpace.Modal);
